import * as S from './styles';

import React, { forwardRef } from 'react';

import { Tab } from './interfaces';
import { UdTab } from './ud-tab';
import classNames from 'classnames';

type Props = {
  tabs: Tab[];
  beforeChangeTab?: (hash: string) => any;
  className?: string;
  defaultTab: Tab;
};

const UDTabs = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { tabs, className } = props;

  return (
    <S.TabsContainer className={classNames('flex items-center flex flex-row', className)} ref={ref}>
      {tabs.map((tab) => (
        <UdTab key={tab.hash} tab={tab} />
      ))}
    </S.TabsContainer>
  );
});

export default UDTabs;
